import React, { useEffect, type ComponentProps } from 'react';
import { GroupCard } from '@mentimeter/slides-presentation-ui/groups/group-card';
import useOnScreen from '../utils/useOnScreen';
import { useAssignedClusterStore } from './utils/useAssignedClusterStore';

type UngroupedGroupCardProps = Omit<
  ComponentProps<typeof GroupCard>,
  'innerRef' | 'isPulsing'
>;

export const UngroupedGroupCard = ({
  title,
  groupShape,
  tag,
  onClick,
  groupId,
  shouldShowVotes = false,
  upvotes = 0,
  isTopVoted = false,
  responses,
  translate,
  disabled = false,
}: UngroupedGroupCardProps) => {
  const newResponsesRef = React.useRef<HTMLButtonElement | null>(null);

  const isNewResponsesCardVisible = useOnScreen(newResponsesRef);

  const { pulseNewResponsesIntoView, setAreNewResponsesVisible } =
    useAssignedClusterStore((state) => state);

  useEffect(() => {
    if (pulseNewResponsesIntoView) {
      newResponsesRef?.current?.scrollIntoView();
    }
  }, [pulseNewResponsesIntoView]);

  useEffect(() => {
    setAreNewResponsesVisible(isNewResponsesCardVisible);
  }, [isNewResponsesCardVisible, setAreNewResponsesVisible]);

  return (
    <GroupCard
      innerRef={newResponsesRef}
      title={title}
      groupShape={groupShape}
      tag={tag}
      groupId={groupId}
      onClick={onClick}
      upvotes={upvotes}
      shouldShowVotes={shouldShowVotes}
      responses={responses.map((response) => ({ text: response.text }))}
      translate={translate}
      isTopVoted={isTopVoted}
      isPulsing={pulseNewResponsesIntoView}
      disabled={disabled}
    />
  );
};
